import { FC, useEffect, FormEvent } from 'react';
import { Box, Button } from '@mui/material';

import { RooftopCreateDto, RooftopsCreateDto } from '@libs/dto';
import { useRooftop } from '@carcareers/hooks';
import { RooftopPermissionsInput, RooftopsInput } from '@carcareers/components';
import { useDrawer, useForm } from '@carcareers/contexts';

export interface RooftopCreateFormProps {
  onSuccess?: () => void;
}

export const RooftopCreateForm: FC<RooftopCreateFormProps> = ({ onSuccess }) => {
  const { setOpen } = useDrawer();
  const { createRooftop } = useRooftop();
  const { data, setErrors } = useForm<RooftopsCreateDto>();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    const callbacks = onSuccess ? { onSuccess } : undefined;
    const response = await createRooftop(data, callbacks);

    if (response?.data) {
      setOpen(false);
    } else if (response?.errors) {
      setErrors(response.errors);
    }
  };

  useEffect(() => {
    return () => {
      setOpen(false);
    };
  }, [setOpen]);

  return (
    <>
      <RooftopPermissionsInput />
      <RooftopsInput<RooftopCreateDto[]> type="rooftops" />
      <Box
        sx={(theme) => ({
          display: 'flex',
          gap: theme.spacing(2),
          justifyContent: 'flex-end',
          [theme.breakpoints.down('sm')]: { flexDirection: 'column-reverse' },
          [theme.containerQueries('drawer').down(500)]: { flexDirection: 'column-reverse' },
        })}
      >
        <Button size="large" variant="outlined" color="secondary" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button size="large" variant="contained" color="primary" onClick={handleSubmit}>
          Create Rooftop
        </Button>
      </Box>
    </>
  );
};

export default RooftopCreateForm; 